// a function that takes a value and a number that can be 0 and returns the value divided by the number
// In the case of a division by 0, the function returns 0 and prevents NaN or Infinity values.
export const divide = (value: number, by: number) =>
  by === 0 ? 0 : value / by;
